import React, { useState } from 'react'
import { ReactComponent as Spinner } from '../../images/icons/spinner.svg'

const SaveButton = ({
                     label,
                     disabled,
                     outline,
                     saveHandler,
                   }) => {
  const [loadingSave, setLoadingSave] = useState(false)

  const doSave = async () => {
    try {
      setLoadingSave(true)
      await saveHandler()
    } catch (e) {
      console.error(e)
    } finally {
      setLoadingSave(false)
    }
  }

  const classes = outline
    ? 'btn btn-outline-secondary dart-btn-outline ml-3'
    : 'btn btn-secondary dart-btn ml-3'
  const styleObj = {}
  if (outline) styleObj.backgroundColor = '#FFFFFF'

  return (
    <button className={classes}
            style={styleObj}
            onClick={doSave}
            disabled={disabled || loadingSave}>
      { loadingSave
        ? <Spinner className={'rot'} style={{ width: 25, top: -4, position: 'relative' }}/>
        : label
      }
    </button>
  )
}

export default SaveButton
